import React, { createContext, useContext } from 'react';

import type { SiteVersion } from '../../../core/system/rendering/types.js';

type RenderContextValue = {
  isHermesApp: boolean;
  siteVersion: SiteVersion;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

const RenderContext = createContext<RenderContextValue | undefined>(undefined);

const RenderContextProvider: React.FC<
  React.PropsWithChildren<{ isHermesApp: boolean; siteVersion: SiteVersion }>
> = ({ siteVersion, isHermesApp, children }) => (
  <RenderContext.Provider
    value={{
      isHermesApp,
      siteVersion,
      isMobile: siteVersion === 'phone',
      isTablet: siteVersion === 'tablet',
      isDesktop: siteVersion === 'desktop',
    }}
  >
    {children}
  </RenderContext.Provider>
);

const useRenderContext = (): RenderContextValue => {
  const ctx = useContext(RenderContext);

  if (!ctx) {
    throw new Error(
      'useRenderContext must be used within a <RenderContextProvider>.',
    );
  }

  return ctx;
};

export { RenderContextProvider, useRenderContext };
